import styled, { css } from "styled-components";

export const TableHolder = styled.div`
  padding: ${({ noPadding }) => (noPadding ? "0" : "20px 20px 9px")};
  /* background: var(--base-background-color); */
  padding-top: 15px;

  @media (min-width: 1200px) {
    padding-top: 10px;
  }

  height: 100%;

  ${({ responsive }) =>
    responsive
      ? css`
          @media (min-width: 1200px) {
            padding: 20px;
          }
          @media (min-width: 992px) {
            /* background: var(--gray-4); */
            padding: 0;
          }
        `
      : css`
          background: var(--light);
        `}
`;

export const TableScroll = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: ${({ $noPaddingBottom }) =>
    $noPaddingBottom ? $noPaddingBottom : "75px"};
`;

export const StyledTable = styled.table`
  width: 100%;
  height: ${({ $fullHeight }) => ($fullHeight ? "100%" : "auto")};
  border-collapse: collapse;
  color: #7d8398;
  font-family: var(--base-font-serif);
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  
  @media (min-width: 1450px) {
    font-size: 14px;
    line-height: 18px;
  }


  /* border: 1px solid #fcfcfc; */


  ${({ noNewStyle = false }) => !noNewStyle && css`
  padding: 0 15px;
  border-collapse: separate !important;
  border-spacing: 0 12px;
  @media (min-width: 1450px) {
    padding: 0 20px;
  }
  `}

  ${({ responsive }) =>
    responsive
      ? css`
          @media (min-width: 992px) {
            min-width: ${({ $width }) =>
          $width &&
          `${$width}px`}; /* width on which horizontal scroll will appear */
          }
        `
      : css`
          min-width: ${({ $width }) => $width && `${$width}px`};
        `}



/* .separator {
height: 12px;
width: 100%;
background: red;
border-bottom: none;
} */
`;

export const Thead = styled.thead`
  ${({ responsive }) =>
    responsive
      ? css`
          @media (max-width: 991px) {
            display: none;
          }
        `
      : css`
          display: table-header-group;
        `}

  .table-head {
  border-bottom: 1px solid var(--table-border);

    th {
    color: #121212;
    font-weight: 500;
    
    ${({ noNewStyle }) => !noNewStyle && css`
    padding-top: 0;
    padding-bottom: 10px;
    `}

      &:first-child {
      padding-left: 15px;
      text-align: left;
    }
      &:last-child {
      /* padding-right: 15px; */
      /* text-align: right; */
    }
  }

    &::before {
    visibility: hidden;
  }
  
    &::after{
    visibility: hidden;
  }
}

`;

export const TBody = styled.tbody`
  ${({ responsive }) =>
    responsive &&
    css`
      @media (max-width: 991px) {
        display: grid;
        grid-template-columns: repeat(2, minmax(0px, 1fr));
        gap: 10px;
      }

      @media (max-width: 767px) {
        grid-template-columns: repeat(1, minmax(0px, 1fr));
      }
    `}

  .sequence-row {
    td {
    font-size: 16px;
    text-align: center;
    padding: 10px;
  }
}
`;

export const NoRecordFound = styled.span`
display: block;
max-width: 200px;
padding: 15px 10px 13px;
margin: 15px auto;
border-radius: 5px;
color: var(--danger);
background: #ffebeb;
text-align: center;
`;
